/**
 * Convert value into boolean.
 */
export function toBoolean(bool: unknown) {
    if (typeof bool === 'boolean') {
        return bool;
    } else if (typeof bool === 'string') {
        const val = bool.toLowerCase();
        return val.length > 0 && val !== 'false' && val !== '0';
    } else if (typeof bool === 'number') {
        return bool !== 0;
    } else {
        return !!bool;
    }
}

/**
 * Invert provided boolean.
 */
export function invertBoolean(bool: unknown) {
    return !toBoolean(bool);
}
